export function convertToHumanReadable(input?: string) {
  if (!input) {
    return input;
  }

  // Replace underscores with spaces, and capitalize each word
  return input
    .replace(/_/g, ' ') // Replace underscores with spaces
    .toLowerCase() // Convert everything to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
}

export function pluralize(word: string): string {
  if (word.toLowerCase().endsWith('y')) {
    const vowelRegex = /[aeiouAEIOU]/;
    if (!vowelRegex.test(word[word.length - 2])) {
      return word.slice(0, -1) + 'ies';
    }
  }
  return word + 's';
}
